import { pluralize } from "@common/helpers/string";

/**
 * Builds a display label for a multi-select column cell.
 * - Empty → "-"
 * - Single item → the resolved label string
 * - Multiple items → "N <noun>" (pluralized)
 */
export function buildMultiSelectLabel(
    values: string[] | null | undefined,
    labelMap: Record<string, string>,
    noun: string,
): string {
    if (!values || values.length === 0) {
        return "-";
    }
    if (values.length === 1) {
        return labelMap[values[0]] ?? values[0];
    }
    return `${values.length} ${pluralize(noun, values.length)}`;
}
